let images = [...document.querySelectorAll('.lazy-image')];

const interactSettings = {
    root: document.querySelector('.center'),
    rootMargin: '0px 0px 200px 0px'
};

function onIntersection(imageEntites) {
    imageEntites.forEach(image => {
        if (image.isIntersecting) {
            observer.unobserve(image.target);
            image.target.src = image.target.dataset.src;
            image.target.onload = () => image.target.classList.add('loaded');
        }
    });
}

let observer = new IntersectionObserver(onIntersection, interactSettings);

images.forEach(image => observer.observe(image));

var _rtl = false;
$(document).ready(function () {
    'use strict'

    if ($('body').css('direction') == 'rtl') {
        _rtl = true;
    }
    // ================================= -{</>}- ============================

    if (_rtl) {
        // show and hide navbar collapse from Right for Arabic
        $('.navbar .toggler').on('click', function () {
            $('.navbar .navbar-collapse').animate({
                right: 0
            }, 100).css('box-shadow', '-7px 0px 30px rgba(0,0,0,0.4)');
        });
        // Hide Side Navbar When Click Outside for Arabic
        $(document).on("click", function (event) {
            var $trigger = $('.navbar');
            if ($trigger !== event.target && !$trigger.has(event.target).length) {
                $('.navbar .navbar-collapse').animate({
                    right: '-307px'
                }, 100).css('box-shadow', 'none')
            }
        });
        // hide side navbar when click icon close
        $('.navbar .navbar-collapse .close-nav').on('click', function () {
            $('.navbar .navbar-collapse').animate({
                right: '-307px'
            }, 100).css('box-shadow', 'none');
        });

    } else {
        // show and hide navbar collapse from left for english
        $('.navbar .toggler').on('click', function () {
            $('.navbar .navbar-collapse').css({'left': '0', 'box-shadow': '7px 0px 30px rgba(0,0,0,0.4)'})
        });
        // Hide Side Navbar When Click Outside
        $(document).on("click", function (event) {
            var $trigger = $('.navbar ');
            if ($trigger !== event.target && !$trigger.has(event.target).length) {
                $('.navbar .navbar-collapse').css({'left': '-307px', 'box-shadow': 'none'})
            }
        });
        // hide side navbar when click icon close
        $('.navbar .navbar-collapse .close-nav').on('click', function () {
            $('.navbar .navbar-collapse').css({'left': '-307px', 'box-shadow': 'none'})
        });

    }

    // // ================================= -{</>}- ============================

    if ($(".owl4Items").length) {
        $(".owl4Items").owlCarousel({
            items: 4,
            autoplay: false,
            loop: true,
            nav: true,
            lazyLoad: true,
            margin: -2,
            navText: [
                '<img src="/assets/img/arrows/owl-nav-top-arrow-prev.png" alt="arrow image">',
                '<img src="/assets/img/arrows/owl-nav-top-arrow-next.png" alt="arrow image">'
            ],
            rtl: _rtl,
            dots: false,
            responsive: {
                0: {
                    items: 1
                },
                768: {
                    items: 2
                },
                992: {
                    items: 3
                },
                1200: {
                    items: 4
                }
            }
        });
    }
    // ================================= -{</>}- ============================

    if ($(".owl3Items").length) {
        $(".owl3Items").owlCarousel({
            items: 3,
            autoplay: false,
            loop: true,
            nav: true,
            margin: -2,
            navText: [
                '<img src="/assets/img/arrows/owl-nav-top-arrow-prev.png" alt="arrow image">',
                '<img src="/assets/img/arrows/owl-nav-top-arrow-next.png" alt="arrow image">'
            ],
            rtl: _rtl,
            dots: false,
            responsive: {
                0: {
                    items: 1
                },
                768: {
                    items: 2
                },
                1200: {
                    items: 3
                }
            },
            onChange: function () {
                let images = [...this.$stage[0].querySelectorAll('.lazy-image')];
                images.forEach(image => observer.observe(image));
            }
        });
    }
    // ================================= -{</>}- ============================

    if ($("#vision-carousel").length) {
        $("#vision-carousel").owlCarousel({
            items: 1,
            mouseDrag: true,
            loop: true,
            rtl: _rtl,
            nav: true,
            dots: false,
            navText: [
                '',
                '<i class="fas fa-angle-right"></i>',
            ],
        });
    }
    // ================================= -{</>}- ============================

    if ($("#testimonials-carousel").length) {
        $("#testimonials-carousel").owlCarousel({
            center: true,
            mouseDrag: true,
            loop: true,
            rtl: _rtl,
            nav: true,
            navText: [
                '<img src="/assets/img/arrows/owl-nav-top-arrow-prev-white.png" alt="arrow image">',
                '<img src="/assets/img/arrows/owl-nav-top-arrow-next-dark.png" alt="arrow image">'
            ],
            dots: false,
            responsive: {
                0: {
                    items: 1,
                },
                992: {
                    items: 2
                }
            },
            onChange: function () {
                let images = [...this.$stage[0].querySelectorAll('.lazy-image')];
                images.forEach(image => observer.observe(image));
            }
        });
    }
    // ================================= -{</>}- ============================

    // companies Carousel
    $('.companies-carousel').owlCarousel({
        loop: true,
        margin: 10,
        rtl: _rtl,
        nav: true,
        dots: false,
        navContainer: '.nav-container',
        touchDrag: true,
        autoplay: true,
        autoplaySpeed: 500,
        autoplayHoverPause: true,
        autoplayTimeout: 2000,
        navText: ['<svg xmlns="http://www.w3.org/2000/svg" width="30.64" height="28.719" viewBox="0 0 30.64 28.719"><defs><style>.next-prev{fill:#e4e4e4;}.b{fill:#37404d;}</style></defs><g transform="translate(-1594.289 -3966)"><circle class="next-prev" cx="14.36" cy="14.36" r="14.36" transform="translate(1596.209 3966)"/><path class="b" d="M9.945,17.77,8.172,19.46a.591.591,0,0,1-1-.435V1.2A1.2,1.2,0,0,0,5.975,0h.011A1.2,1.2,0,0,0,4.779,1.2v17.81a.606.606,0,0,1-1.024.431L2.011,17.759a1.188,1.188,0,0,0-1.687.047l0,0A1.185,1.185,0,0,0,.371,19.48l3.995,3.8a2.393,2.393,0,0,0,3.295-.01l3.923-3.769a1.184,1.184,0,0,0,.05-1.664l-.011-.012A1.185,1.185,0,0,0,9.945,17.77Z" transform="translate(1594.289 3986.594) rotate(-90)"/></g></svg>', '<svg xmlns="http://www.w3.org/2000/svg" width="30.64" height="28.719" viewBox="0 0 30.64 28.719"><defs><style>.a{fill:#e4e4e4;}.b{fill:#37404d;}</style></defs><g transform="translate(-1594.289 -3966)"><circle class="next-prev" cx="14.36" cy="14.36" r="14.36" transform="translate(1596.209 3966)"/><path class="b" d="M9.945,17.77,8.172,19.46a.591.591,0,0,1-1-.435V1.2A1.2,1.2,0,0,0,5.975,0h.011A1.2,1.2,0,0,0,4.779,1.2v17.81a.606.606,0,0,1-1.024.431L2.011,17.759a1.188,1.188,0,0,0-1.687.047l0,0A1.185,1.185,0,0,0,.371,19.48l3.995,3.8a2.393,2.393,0,0,0,3.295-.01l3.923-3.769a1.184,1.184,0,0,0,.05-1.664l-.011-.012A1.185,1.185,0,0,0,9.945,17.77Z" transform="translate(1594.289 3986.594) rotate(-90)"/></g></svg>'],
        navClass: ['owl-prev', 'owl-next'],
        mouseDrag: true,
        responsive: {
            0: {
                items: 2,
            },
            350: {
                items: 3,
                margin: 5,
            },
            768: {
                items: 4,
            },
            992: {
                items: 6,
            },
            1200: {
                items: 7,
            },
        },
        onChange: function () {
            let images = [...this.$stage[0].querySelectorAll('.lazy-image')];
            images.forEach(image => observer.observe(image));
        }
    });
    // ================================= -{</>}- ============================

    if ($("#partners-carousel").length) {
        $("#partners-carousel").owlCarousel({
            items: 6,
            autoplay: false,
            loop: true,
            nav: false,
            lazyLoad: true,
            rtl: _rtl,
            dots: false,
            responsive: {
                0: {
                    items: 2
                },
                576: {
                    items: 3
                },
                768: {
                    items: 4
                },
                992: {
                    items: 5
                },
                1200: {
                    items: 6
                }
            },
            onChange: function () {
                let images = [...this.$stage[0].querySelectorAll('.lazy-image')];
                images.forEach(image => observer.observe(image));
            }
        });
    }
    // ================================= -{</>}- ============================

    if ($("#event-slider").length) {
        var event_slider = $("#event-slider").owlCarousel({
            items: 1,
            rtl: _rtl,
            loop: true,
            nav: true,
            navText: [
                '<i class="fas fa-angle-left"></i>',
                '<i class="fas fa-angle-right"></i>',
            ],
            dots: false,
            thumbs: true,
            thumbImage: true,
        });
        $("#event-slider .owl-thumbs").mThumbnailScroller({axis: "x"});
    }

    $(".phoneInput").keydown(function (event) {
        // Allow: backspace, delete, tab, escape, and enter
        if (event.keyCode == 46 || event.keyCode == 8 || event.keyCode == 9 || event.keyCode == 27 || event.keyCode == 13 ||
            // Allow: Ctrl+A
            (event.keyCode == 65 && event.ctrlKey === true) ||
            // Allow: home, end, left, right
            (event.keyCode >= 35 && event.keyCode <= 39)) {
            // let it happen, don't do anything

        } else {
            // Ensure that it is a number and stop the keypress
            if (event.shiftKey || (event.keyCode < 48 || event.keyCode > 57) && (event.keyCode < 96 || event.keyCode > 105)) {
                event.preventDefault();
            }
        }
    });

    //initilaize Language, FullSrc and Domain name
    var language = $('html').attr('lang');
    var fullsrc = $(location).attr('href');
    var domain = $(location).attr('hostname');

    // Validation Rules
    var emailReg = /^([\w\-\.]{2,}\@[a-zA-Z-0-9]{2,}\.[\w\-]{2,4})/;
    var numReg = /[0-9]/;

    // ================================= -{</>}- ============================


    /***
     * ================================
     * Initialization Toaster messages
     * ================================
     */
    toastr.options = {
        "closeButton": true,
        "debug": false,
        "newestOnTop": false,
        "progressBar": true,
        "positionClass": "toast-top-right",
        "preventDuplicates": false,
        "onclick": null,
        "showDuration": "300",
        "hideDuration": "1000",
        "timeOut": "5000",
        "extendedTimeOut": "1000",
        "showEasing": "swing",
        "hideEasing": "linear",
        "showMethod": "fadeIn",
        "hideMethod": "fadeOut"
    };
    // ================================= -{</>}- ============================

    /***
     * ================================
     * Error Messages with Languages
     * ================================
     */
    var $choiceCountyCode = '', $errorEmailMsg = '', $errorMessageMsg = '', $pleaseEnterEmailMsg = '',
        $pleaseEnterNameMsg = '', $pleaseEnterMobileMsg = '', $filesValidateType = '', $choise = '',
        $pleaseEnterNumberOnly = '', $pleaseEnterValidMobileMsg = '', $TooManyAttempts = '', $forbidden = '';
    // -- English
    if (language === 'en') {
        $choiceCountyCode = 'Please Enter Country Code';
        $errorEmailMsg = 'Invalid Email ';
        $errorMessageMsg = 'Please Enter Your Message ';
        $pleaseEnterNameMsg = 'Please Enter Name';
        $pleaseEnterEmailMsg = 'Please Enter Email';
        $pleaseEnterMobileMsg = 'Please Enter Mobile Number';
        $pleaseEnterNumberOnly = 'Phone number must be numbers only';
        $pleaseEnterValidMobileMsg = 'Phone number must include more than 5 numbers';
        $TooManyAttempts = 'Too many attempts, please slow down the request.';
        $filesValidateType = 'The files must be a file of type:  jpg, png, jpeg, jfif,doc,docx or pdf.';
        $choise = 'country';
        $forbidden = 'The email field has already been taken';
    }
    // -- French
    else if (language === 'fr') {
        $choiceCountyCode = 'Veuillez choisir le code du pays';
        $errorEmailMsg = 'Mauvaise adresse email à l\'inscription';
        $errorMessageMsg = 'Please Enter Your Message ';
        $pleaseEnterNameMsg = 'S\'il vous plaît entrez votre nom';
        $pleaseEnterEmailMsg = ' S\'il vous plaît entrez votre adresse email';
        $pleaseEnterMobileMsg = 'S\'il vous plaît entrez votre numéro de téléphone';
        $pleaseEnterNumberOnly = 'Phone number must be numbers only';
        $pleaseEnterValidMobileMsg = 'Le numéro de téléphone doit comporter plus de 5 chiffres.';
        $TooManyAttempts = 'Trop de demandes. Veuillez réessayer après 60 secondes.';
        $filesValidateType = 'Les fichiers doivent être d\'un type de fichier: jpg, png, jpeg, jfif, doc, docx ou pdf.';
        $choise = 'pays';
        $forbidden = 'The email field has already been taken';
    }
    // -- Arabic
    else {
        $choiceCountyCode = 'الرجاء اختيار رمز البلد ';
        $errorEmailMsg = 'عنوان البريد الالكتروني خاطئ ';
        $errorMessageMsg = 'الرجاء ادخال رسالتك';
        $pleaseEnterNameMsg = 'الرجاء ادخال الاسم';
        $pleaseEnterEmailMsg = ' الرجاء ادخال البريد الاكتروني';
        $pleaseEnterMobileMsg = 'الرجاء ادخال رقم الهاتف';
        $pleaseEnterNumberOnly = 'رقم الهاتف يجب ان يكون ارقام فقط';
        $pleaseEnterValidMobileMsg = 'رقم الهاتف يجب أن يكون أكبر من 5 أرقام';
        $TooManyAttempts = 'عدد كبير جدا من الطلبات . يرجى المحاولة مرة أخرى بعد 30 ثانية';
        $filesValidateType = ' يجب أن يكون ملفًا من نوع   jpg, png, jpeg, jfif,doc,docx,pdf,';
        $choise = 'اختر البلد';
        $forbidden = 'هذا الايميل مسجل مسبقا';
    }
    // ================================= -{</>}- ============================

    // On click Enter In contact  or subscribe form make button clicked
    $('.contact-form,.subscribe-form').on('keypress', function (e) {
        var keyCode = e.keyCode || e.which;
        if (keyCode === 13) {
            e.preventDefault();
            var $button = $(this).closest('form').find(':button');
            $button.click();
            return false;
        }
    });
    // ================================= -{</>}- ============================

    // On Click SUBMIT Contact Forms
    $('.btn-send-message').on('click', function (e) {
        e.preventDefault();
        $.ajax({
            url: '/csrf',
            method: 'get',
            dataType: 'text',
            async: false,
            success: function (response) {
                if (JSON.parse(response)) {
                    $('meta[name="csrf-token"]').attr('content', JSON.parse(response).token);
                }
            }
        });
        $.ajaxSetup({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            }
        });
        var $form = $(this).parents('form');
        var phoneId = $form.find(".phoneInput").attr('id');
        var iti = window.intlTelInputGlobals.getInstance(document.getElementById(phoneId));
        var name = $form.find('input[name=name]').val();
        var phone = $form.find('input[name=phone]').val();
        var email = $form.find('input[name=email]').val();
        var message = $form.find('textarea[name=message]').val();
        var mobile_number_with_code = iti.getNumber();
        var countryData = iti.getSelectedCountryData();
        var countryCode = countryData.dialCode;
        var formData = new FormData($form[0]);
        formData.append('communication_time', '');
        formData.append('fullsrc', fullsrc);
        formData.append('domain', domain);
        formData.append('locale', language);
        formData.append('_token', $('meta[name="csrf-token"]').attr('content'));
        var valid = true;
        var validMsg = '';
        if (name == '') {
            valid = false;
            validMsg = $pleaseEnterNameMsg;
        } else if (phone == '') {
            valid = false;
            validMsg = $pleaseEnterMobileMsg;
        } else if (!numReg.test(phone)) {
            valid = false;
            validMsg = $pleaseEnterNumberOnly;
        } else if (mobile_number_with_code.length < 5) {
            valid = false;
            validMsg = $pleaseEnterValidMobileMsg;
        } else if (email != '' && !emailReg.test(email)) {
            valid = false;
            validMsg = $errorEmailMsg;
        }
        if (validMsg != '')
            toastr.warning(validMsg);
        if (valid) {
            $('.btn-send-message').prop('disabled', true);
            $.ajax({
                url: $form.attr('action'),
                method: "POST",
                xhr: function () {
                    return $.ajaxSettings.xhr();
                },
                data: formData,
                cache: false,
                contentType: false,
                processData: false,
                dataType: "json",
                beforeSend: function () {
                    $form.find('.send').addClass('d-none');
                    $form.find('.sending').removeClass('d-none');
                },
                success: function (data) {
                    if (data.error.length > 0) {
                        toastr.error(data.error);
                    } else {
                        toastr.success(data.success);
                        $form[0].reset();
                    }

                }, error: function (data, status, message) {
                    if (data.status === 429) {
                        toastr.error($TooManyAttempts);
                    } else {
                        toastr.error('حدث خطأ ما , يرجى المحاولة لاحقا ');
                    }
                    $('.btn-send-message').prop('disabled', false);
                }, complete: function () {
                    $form.find('.send').removeClass('d-none');
                    $form.find('.sending').addClass('d-none');
                    $form.find('.submit-form').prop('disabled', false);
                    $('.btn-send-message').prop('disabled', false);
                }
            });
        }
    });
    // ================================= -{</>}- ============================

    // On Click SUBMIT Subscribe Forms
    $('.subscribe-btn').on('click', function (e) {
        e.preventDefault();
        var $this = $(this).parents('form');
        var $button = $(this);
        var email = $this.find('input[name=email]').val();
        if (email == '') {
            toastr.warning($pleaseEnterEmailMsg);
        } else if (!emailReg.test(email)) {
            toastr.warning($errorEmailMsg);
        } else {
            $button.prop('disabled', true);
            $.ajax({
                url: '/csrf',
                method: 'get',
                dataType: 'text',
                async: false,
                success: function (response) {
                    // set new token
                    if (JSON.parse(response)) {
                        $('meta[name="csrf-token"]').attr('content', JSON.parse(response).token);
                    }
                }
            }).done(function () {
                $.ajax({
                    url: $this.attr('action'),
                    method: "POST",
                    dataType: "json",
                    data: {
                        email: email,
                        locale: language,
                        _token: $('meta[name="csrf-token"]').attr('content'),
                    },
                    beforeSend: function () {
                        $this.find('.subscribe').addClass('d-none');
                        $this.find('.subscribing').removeClass('d-none');
                    },
                    success: function (data) {
                        toastr.success(data.success);
                        $this[0].reset();
                    }, error: function (data, status, message) {
                        $this.find('.subscribe').removeClass('d-none');
                        $this.find('.subscribing').addClass('d-none');
                        $button.prop('disabled', false);

                        if (data.status === 429) {
                            toastr.error($TooManyAttempts);
                        } else if (message === 'Forbidden') {
                            toastr.error($forbidden);
                        } else {
                            toastr.error('حدث خطأ ما , يرجى المحاولة لاحقا ');
                        }

                        $button.prop('disabled', false);
                    }
                    , complete: function () {
                        $this.find('.subscribe').removeClass('d-none');
                        $this.find('.subscribing').addClass('d-none');
                        $button.prop('disabled', false);
                    }
                });
            });
        }
    });
    // ================================= -{</>}- ============================

    // smooth scroll for table content
    $(".blog-single-page .mce-toc li > a").bind("click", function (e) {
        var target = $(this).attr("href")
        var headerHeight = $("#header").height() + 15
        var scrollToPosition = $(target).offset().top - headerHeight;
        $('html')
        .css({scrollBehavior: 'unset'})
        .animate({'scrollTop': scrollToPosition}, 1000, function () {
            window.history.pushState(null, '', target);
        });
        e.preventDefault();
    })

    $('.mce-toc [contenteditable]').attr('contenteditable', 'false')

    // to just hide modal when click prev button in browser
    $('.modal').on('shown.bs.modal', function () {
        var urlReplace = '#' + $(this).attr('id')
        history.pushState(null, null, urlReplace)
    })

    $(window).on('popstate', function () {
        $('.modal').modal('hide')
    })
    //-----------

    // This function made specifically for adding aria-label to some 3rd party generated elements
    /* === [Start Add Custom Attribute (Aria-Label) or Remove Attr] === */
    let controlAttrAndVal = (selector, attrProp, attrVal, action) => {
        if (selector.length > 0 && action == 'add') {
            selector.attr(attrProp, attrVal);
        }

        else if (selector.length > 0 && action == 'remove') {
            selector.removeAttr(attrProp);
        }
    }

    controlAttrAndVal($('.owl-dot'), 'aria-label', 'Owl Dots', 'add');
    controlAttrAndVal($('.owl-prev'), 'aria-label', 'Previous Slide', 'add');
    controlAttrAndVal($('.owl-next'), 'aria-label', 'Next Slide', 'add');
    controlAttrAndVal($('.iti__selected-flag > *'), 'role', 'textbox', 'add');
    controlAttrAndVal($('.iti__flag'), 'aria-label', 'country flag', 'add');
    controlAttrAndVal($('.iti__selected-flag'), 'aria-expanded', 'false', 'add');
    controlAttrAndVal($('.iti__selected-flag'), 'aria-controls', 'country', 'add');
    controlAttrAndVal($('.iti__selected-flag'), 'aria-owns', '', 'remove');
    controlAttrAndVal($('.iti__selected-flag'), 'aria-activedescendant', '', 'remove');
    controlAttrAndVal($('.iti__selected-dial-code'), 'aria-label', 'Dial Code', 'add');
    controlAttrAndVal($('.iti__arrow'), 'aria-label', 'Select Country Arrow', 'add');
    controlAttrAndVal($('.works .nav-pills'), 'role', '', 'remove');
    controlAttrAndVal($('.works .nav-pills .nav-item'), 'role', 'tablist', 'add');
    /* === [End Add Custom Attribute (Aria-Label) or Remove Attr] === */
});
